{
  "ACDStatusHotKeys_Success_Available": "Agent \"{}\" ist verfügbar",
  "ACDStatusHotKeys_Success_Unavailable": "Agent \"{}\" ist nicht verfügbar",
  "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Konnte \"{}\" nicht auf verfügbar setzen.\nDieser Agent ist möglicherweise bereits verfügbar oder abgemeldet.",
  "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Konnte \"{}\" nicht auf nicht verfügbar setzen.\nDieser Agent ist möglicherweise bereits nicht verfügbar oder abgemeldet.",
  "NAME": "ACDStatusHotKeys"
}